import script from "./SingleSelectComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SingleSelectComponent.vue?vue&type=script&setup=true&lang=ts"

import "./SingleSelectComponent.vue?vue&type=style&index=0&id=6078e648&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6078e648"]])

export default __exports__